<template>
<div class="marker">
    <svg class="marker__icon marker__icon--observation-default" viewBox="1.5 1.5 30 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-877.000000, -283.000000)">
        <g transform="translate(877.000000, 283.000000)">
          <path d="M15.2,2 C7.90833697,2 2,7.86063194 2,15.0912986 C2,20.7732417 5.65447403,25.5960236 10.7574858,27.4091444 L15.2,39.4 L19.6432999,27.4065472 C24.7447403,25.5973222 28.4,20.7735014 28.4,15.0915583 C28.4007857,7.86063194 22.489306,2 15.2,2" stroke="#FFFFFF" stroke-width="2" fill="#007696"></path>
        </g>
      </g>
    </svg>
</div>
</template>

<script>
export default {

};
</script>
